<script lang="ts" setup>
import { ref, computed, PropType } from "vue";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "vue-chartjs";
import ChartInnerTextPlugin from "./plugins/chartInnerTextPlugin";

import ChartLegend from "./ChartLegend.vue";

ChartJS.register(ArcElement, Tooltip, Legend);

const props = defineProps({
  dataSet: {} as PropType<IChartDataSet>,
  options: {} as Object,
  chartName: String,
  style: Object || null,
  innerText: null as PropType<IInnerChartText[] | null>,
  legendPositionBottom: {
    type: Boolean,
    default: false,
  },
});

const legend = ref<ILegend[] | []>([]);

const htmlLegendPlugin = {
  id: "htmlLegend",
  afterUpdate(chart) {
    const items = chart.options.plugins.legend.labels.generateLabels(chart);

    let total = chartData.value.datasets[0].data.reduce((a: number, b: number) => a + b, 0) as number;
    const data = chartData.value.datasets[0].data;

    legend.value = items.map((item, index) => {
      let percentage = null;

      if (Number(data[index])) {
        percentage = Math.round((Number(data[index]) / total) * 100);
      }

      const legendItem: ILegend = {
        color: item.fillStyle,
        label: item.text,
        percentage: percentage,
      };

      return legendItem;
    });
  },
};

const chartData = computed(() => {
  return {
    labels: props.dataSet.labels,
    datasets: [
      {
        data: props.dataSet.data, // Now this will be a number[]
        backgroundColor: props.dataSet.backgroundColors,
        borderColor: "#FFFFFF",
        borderWidth: 2,
      },
    ],
  };
});

const chartOptions = computed(() => {
  return {
    ...props.options,
    plugins: {
      legend: {
        display: false,
      },
      chartInnerTextPlugin: {
        chartInnerTextPlugin: {
          text: props.innerText,
          percentage: false,
        },
      },
      tooltip: {
        callbacks: {
          title: function () {
            return null;
          },
          label: function (tooltipItems) {
            return `${tooltipItems.label}: ${tooltipItems.formattedValue}`;
          },
        },
      },
    },
  };
});

const chartStyle = computed(() => {
  return (
    props.style ?? {
      width: `${props.radius}px`,
      height: `${props.radius}px`,
      marginLeft: "auto",
      marginRight: "auto",
      position: "relative",
    }
  );
});
</script>

<template>
  <div class="advanced-doughnut" :class="{ 'legend-position-bottom': legendPositionBottom }">
    <div class="doughnut">
      <Doughnut :key="props.chartName" :data="chartData" :options="chartOptions" :style="chartStyle" :plugins="[htmlLegendPlugin, ChartInnerTextPlugin]"> </Doughnut>
    </div>
    <ChartLegend :legend="legend" />
  </div>
</template>
